import { Layout, LayoutHeader, Panel, SaveButton, Switch, Textbox, Tree } from "@mcleod/components";

export abstract class AutogenLayoutPermissionsMain extends Layout {
    layoutPermsGrant: Layout;
    layoutheaderPermsManager: LayoutHeader;
    panelLeft: Panel;
    panelMain: Panel;
    panelTree: Panel;
    panelTreeHeader: Panel;
    savePermsButton: SaveButton;
    switchPermsSet: Switch;
    textSearchMenu: Textbox;
    treeMenu: Tree;
}
